import React from 'react';
import Card from '../../common/Card/Card';
import styles from './OverviewSections.module.css';

/**
 * Key Rules & Eligibility: a list of label / text pairs.
 *
 * A rule with a label but no text is still shown, with a "to be added" line, so
 * a student can see what the guide will cover. An entry with no label is
 * dropped. Renders nothing when there are no rules.
 */
const KeyRules = ({ rules }) => {
  const items = (rules || []).filter((r) => r && r.label);
  if (!items.length) return null;

  return (
    <Card title="Key Rules & Eligibility">
      <div className={styles.rules}>
        {items.map((rule, i) => (
          <div key={`${rule.label}-${i}`} className={styles.rule}>
            <span className={styles.ruleLabel}>{rule.label}</span>
            {rule.text ? (
              <p className={styles.ruleText}>{rule.text}</p>
            ) : (
              <p className={`${styles.ruleText} ${styles.toBeAdded}`}>
                To be added from the CreatED competition guide
              </p>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
};

export default KeyRules;
